import useAiAccess from './useAiAccess'
import useWhoToAsk from './useWhoToAsk'
import { refuse } from '../utils/permissionReason'

/**
 * May the caller open the respondent data view (#1887)? It follows agent
 * access (Adam, 20 Oct: "if you can use the agent, you can use the data
 * view"): the caller's level must reach agent_sessions, the rule the server
 * applies to GET .../casedata/view (RequireAIAccessLevel in job.go) and the
 * one PageAgentButton uses. A used team budget does not take it away: the
 * view spends nothing.
 *
 * customer is the customer NAME.
 */
export interface DataViewAccess {
  allowed: boolean
  /** /me has answered (or failed), so `allowed` is the real answer. */
  decided: boolean
  /** Why not, and who to ask, for DisabledReason. Undefined when allowed. */
  reason: string | undefined
}

export const DATA_VIEW_REFUSAL = "You can't open the data view without agent access."

export function useDataViewAccess(customer: string | undefined): DataViewAccess {
  const aiAccess = useAiAccess(customer)
  const who = useWhoToAsk(customer)
  const allowed = aiAccess.levelAllows('agent_sessions')
  return {
    allowed,
    decided: !aiAccess.loading,
    reason: allowed ? undefined : refuse(DATA_VIEW_REFUSAL, who).reason,
  }
}

export default useDataViewAccess
